export default __webpack_public_path__ + "static/restaurants-qsr-ca15ee5c17d9e1c03a2bf21b1354ccb3.svg";